import "./contact.scss";
import * as React from "react";
import {IconMapPinFilled, IconMailCode, IconBrandGithub} from '@tabler/icons-react';
import {Link} from "@material-ui/core";
import {LinkedIn} from "@material-ui/icons";

export default function Contact(){
    return (
        <div className="contact" id={"contact"}>
            <div className={"title-content"}>
                <h2 className={"title"}>Contact</h2>
                <span className={"divider"}/>
            </div>
            <div className={"content"}>
                <div className={"left"}>
                    <img src={"assets/phone_contact.png"} alt={"contact"}/>
                </div>
                <div className={"right"}>
                    <div className={"mail-content"}>
                        <div className={"header-content-contact"}>
                            <div className={"content"}>
                                <IconMapPinFilled width={40} height={40}/>
                                <div>
                                    <h3 className={"title"}>Localisation</h3>
                                    <span className={"sub-content"}>Nice - France</span>
                                </div>
                            </div>
                            <div className={"content"}>
                                <IconMailCode width={40} height={40} />
                                <div>
                                    <h3 className={"title"}>Email</h3>
                                    <span className={"sub-content"}>
                                    test@gmail.com
                                </span>
                                </div>
                            </div>
                        </div>

                        <div className={"form"}>
                            <input type={"text"} placeholder={"Nom"} className={"inputField"}/>
                            <input type={"text"} placeholder={"Email"} className={"inputField"}/>
                            <textarea placeholder={"Objet"} className={"textField"} />
                            <button className={"btn"}>Envoyer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}